/** * Component - PopUpMessage * * @param {message} Message displayed at center * @param {btnText} Text shown in the button
<!--
============= default =================
 *  <pop-up-message
 *      message="Division has been successfully addded."
 *      btnText="Back To Business Unit"
 *      @back="{function_name}"
 *  >
 *  </pop-up-message>

 ============ custom popup ===========

 <pop-up-message v-if="showModal" :closable="true" :message="`“ File Validation Tool “ required to Validate 24Q text report. `" popupHeaderMessage="Report 24Q Successfully Downloaded." btnText="Ok" @back="okbtn()">
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="okbtn()">Cancel</button>
          <button class="btn-popup" type="button" >Download Tool</button>
        </div>
      </template>
    </pop-up-message>

 =========== Confirm Delete popup =========
 <pop-up-message
      v-if="showPopup"
      :message="'Are you sure you wish to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
      :closable="true"
      @back="backFromPopup">
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancelEvent()"
          >Cancel</button>
          <button class="btn-popup" type="button" @click="deleteEvent()">Delete</button>
        </div>
      </template>
    </pop-up-message>
 -->



* */

<template>
  <div class="modal">
    <div class="modal-content" ref="modalBox":style="{ width: dynamicWidth?dynamicWidth: '30%' }" >
      <div class="img-msg-container animated fadeInRight" v-show="popupType == 'Success'">
        <div class="success-icon">
            <img src="@/assets/checked.svg" class="success-img animated pulse" />
        </div>
          <div class="success-text">{{popupHeaderMessage}}!</div>
      </div>
      <div class="img-msg-container animated fadeInRight" v-show="popupType == 'Warning' || popupType == 'ConfirmDelete'">
        <div class="warning animated shake">
          <img src="@/assets/warning_error.svg" class="warn-img" />
          <div class="warning-text">{{popupHeaderMessage}}!</div>
        </div>
      </div>
      <div class="message-text animated fadeInRight">{{message}}</div>
      <div class="popup-btns animated fadeIn">
        <slot name="bottomContent" v-show="popupType == 'Success'">
          <popup-btn :text="btnText" type="primary" class="btn-filter" @click="goBack()" />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import successIcon from "./success.vue";
  import warningIcon from "@/assets/animations/warning.vue";

  export default {
    props: {
      message: {
        type: String
      },
      btnText: {
        type: String
      },
      popupType: {
        type: String,
        default: "Success"
      },
      popupHeaderMessage: {
        type: String,
        default: "Success"
      },
      dynamicWidth:{
        type: String,
        default: ""
      },
      closable: {
        type: Boolean,
        default: false
      },
    },
    components: {
      successIcon,
      warningIcon
    },
    mounted() {
      this.$root.$el.style.position = "absolute";
      this.$root.$el.style.overflow = "hidden";
      this.$root.$el.style.height = "100%";

      // When PopUpMessage is mounted but not displayed on screen, i.e. when PopUpMessage used with v-show
      // Not Required now, PopUpMessage is used with v-if
      // if (this.$el.style.display == "none") {
      //   this.$root.$el.style.position = "static";
      //   this.$root.$el.style.overflow = "visible";
      //   this.$root.$el.style.height = "auto";
      // }
    },
    beforeDestroy() {
      this.$root.$el.style.position = "static";
      this.$root.$el.style.overflow = "visible";
      this.$root.$el.style.height = "auto";
    },
    methods: {
      goBack() {
        this.$refs.modalBox.classList.add('animated');
        this.$refs.modalBox.classList.add('fadeOutUp');
        setTimeout(() => {
          this.$emit("back");
        }, 1000);
      },
      cancel(){
        // this.$emit("cancelact");
        this.$refs.modalBox.classList.add('animated');
        this.$refs.modalBox.classList.add('fadeOutUp');
        setTimeout(() => {
          this.$emit("cancelact");
        }, 1000);
      },
      deleteBtn(){
        // this.$emit("deleteact");
        this.$refs.modalBox.classList.add('animated');
        this.$refs.modalBox.classList.add('fadeOutUp');
        setTimeout(() => {
          this.$emit("deleteact");
        }, 1000);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "../scss/_variables.scss";
  @import "../scss/animate.css";
  @import "../scss/components/btn.scss";

  .modal {
    display: block;
    position: fixed;
    z-index: 6;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // background-color: rgba(0, 0, 0, 0.3);
    background: rgba(0, 0, 0, 0.60);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(10px);
  }

  /* Modal Content */

  .modal-content {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 30%;
    // height: 191px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    opacity: 0;
    padding: 30px 30px 30px 30px;
    -webkit-animation-name: showPopup;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
    // -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-fill-mode: forwards;

    .success-icon {
      // margin-bottom: 40px;
    }

    .success-text {
      font-size: $font-size-l1;
      font-weight: 600;
      // margin-bottom: auto;
      margin-left: 12px;
      color: #6e6e6e;
    }

    .message-text {
      font-size: $font-size-l1;
      margin-bottom: 40px;
      animation-delay: 0.7s;
      animation-name: fadeInRight;
      -webkit-animation-name: fadeInRight;
      white-space: pre-line;
    }
    .btn-confirm-delete{
      display: flex;
      align-items: center;
      *:nth-child(n){
        margin-right: 20px;
      }
    }
    .warning {
      margin-bottom: 16px;
      text-align: center;
      height: 24px;
      width: 24px;
    }
    .btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: $color-primary;
      color: $color-white;
    }
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 2px;
      color: #34c0be;
    }

    .close-btn {
      position: relative;
      transform: scale(2);
      left: 230px;
      bottom: 20px;
      cursor: pointer;
    }
  }
  .success-img {
    position: relative;
    height: 24px;
    width: 24px;
    &.animated {
      animation-name: pulse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      -webkit-animation-name: pulse;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 3s;
    }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showc {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 1; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
@-webkit-keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}

@keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}
}
@-webkit-keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}

}
</style>
